import Avatar from '@mui/material/Avatar';
import { Helpers } from 'application/Shared/Helpers';
import * as React from 'react';

function stringAvatar(props: { children: string; sx: React.CSSProperties }) {
    const { children, sx } = props;
    const [firstName, lastName] = children.split(' ');
    const initials = `${firstName[0]}${lastName ? lastName[0] : firstName[1]}`;
    return {
        children: initials,
        sx: {
            ...sx,
            bgcolor: Helpers.stringToColor(children.toString(), 40, 50),
            textTransform: 'uppercase'
        }
    };
}

export const StringAvatar = (props: {
    children: string;
    sx: React.CSSProperties;
}) => <Avatar {...stringAvatar(props)} />;
